module.exports = __webpack_public_path__ + "static/media/01.422752b3.webp";